import styled, { keyframes } from "styled-components";
import pic1 from "../images/wellwishers/portfolio-2.jpeg";
import pic2 from "../images/wellwishers/portfolio-3.jpeg";
import pic3 from "../images/wellwishers/portfolio-4.jpeg";

import Reveal from "./Shared/Reveal";
import { Container, H2 } from "./Shared/ui";

const SPONSORS = [pic1, pic2, pic3];

// The sponsor banners scroll as a slow marquee. The list is rendered twice so
// the loop is seamless; the copy is hidden from assistive tech.
const WellWishers = () => {
  return (
    <Wrap>
      <Container>
        <Reveal>
          <H2>Our well wishers</H2>
        </Reveal>
      </Container>

      <Viewport>
        <Track>
          {[...SPONSORS, ...SPONSORS].map((src, i) => (
            <Slide key={i} aria-hidden={i >= SPONSORS.length}>
              <img src={src} alt={i < SPONSORS.length ? "Advertisement from one of our well wishers" : ""} loading="lazy" />
            </Slide>
          ))}
        </Track>
      </Viewport>
    </Wrap>
  );
};

const scroll = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
`;

const Wrap = styled.section`
  padding: clamp(56px, 7vw, 88px) 0;
  border-top: 1px solid var(--border);
  overflow: hidden;

  h2 {
    font-size: clamp(26px, 3vw, 34px);
  }
`;

const Viewport = styled.div`
  margin-top: 28px;
  -webkit-mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);
  mask-image: linear-gradient(90deg, transparent, #000 8%, #000 92%, transparent);

  &:hover > div {
    animation-play-state: paused;
  }

  @media (prefers-reduced-motion: reduce) {
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-mask-image: none;
    mask-image: none;
  }
`;

const Track = styled.div`
  display: flex;
  width: max-content;
  gap: 24px;
  padding: 8px 12px;
  animation: ${scroll} 40s linear infinite;
`;

const Slide = styled.div`
  flex: none;
  height: clamp(160px, 22vw, 240px);
  border-radius: 16px;
  overflow: hidden;
  background: var(--surface);
  border: 1px solid var(--border);
  box-shadow: var(--shadow);
  scroll-snap-align: start;

  img {
    height: 100%;
    width: auto;
    object-fit: contain;
  }
`;

export default WellWishers;
